import { render, staticRenderFns } from "./CommentDetail.vue?vue&type=template&id=01aa2074&scoped=true"
import script from "./CommentDetail.vue?vue&type=script&lang=js"
export * from "./CommentDetail.vue?vue&type=script&lang=js"
import style0 from "./CommentDetail.vue?vue&type=style&index=0&id=01aa2074&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01aa2074",
  null
  
)

export default component.exports